
import React, { useState , useEffect} from "react";
import { Oval } from  'react-loader-spinner'
import { loaderBar ,  apibaseURl ,  changeDateFotmate, currencySymbol , loggedInUserDetails , loggedInCustomerDetails } from '../../functions/Function';
const  Activity = (props) => {
  const [data, setData] = useState([]);
  const [isloading, setisloading] = useState(true);
  const timer = () =>
  {
    setTimeout(() => {
      setisloading(false);
    }, 2000);
  } 
  const fetchData = () => {
    fetch(apibaseURl + "activitylogs?user_id="+loggedInCustomerDetails('id'))
      .then(res => res.json())
      .then((result) => {
        if (result.result == true) {
            setData(result.response);
            timer()
        }
      }
      )
  }
  useEffect(() => {
    fetchData();
    
  }, [])
  return (
    <>
       <div className="account-right-content-shdow">
          <h5 className="account-tab-heading">
              Activity Logs
          </h5>
          { isloading == true && 
              <>
                {loaderBar(200 , 25)}
              </>
                
          }
          { isloading == false && 
            <div className="active-logs-table">
                {Object.keys(data).length > 0 ? data.map((row, i) => (
                    
                    <div className="active-logs-row">
                      <div className="active-logs-headings">
                          <h5>DATE:</h5>
                          <h5>IP:</h5>
                          <h5>ACTIVITY:</h5>
                      </div>

                      <div className="active-logs-content">
                          <h6>
                            {changeDateFotmate(row.created_date , 'ddd DD-MMM-YYYY, hh:mm A')}
                          </h6>
                          <h6>
                          {row.ip}
                          </h6>
                          <h6>
                            <div className="management-ancor">
                                <span className="fontforteen text-success">Login
                                Success</span>
                            </div>
                          </h6>
                      </div>
                    </div>
                      ))
                    : 
                      <div className="text-center"><h5>Data Not Found</h5></div>
                  }
              </div>
          }
        </div>            
    </>

  );
}

export default Activity;
